export default {  
  activeMenu: (state, getters, rootState) => {
    const name = rootState.route.name;
    return name ? state.console_menu.find(el => el === name || el.includes(name)) : null;
  },
  console_menu: state => state.console_menu,
  rpcServerRunning: state => state.rpcServerRunning,
};
